<template>
  <div class="tdesk-container">
    <div class="small-form">
      <p class="tdesk-paragraph-large" style="margin-bottom: 19px;">
        What is your email address?
      </p>
      <label for="email">Email</label>
      <form @submit.prevent="proceed()">
        <div id="form-errors" class="form-errors">
          <form-errors :errors="errors" />
        </div>
        <div class="form-group" style="display:flex; flex-direction:row;">
          <input
            id="email"
            v-model="email"
            type="email"
            name="email"
            required
            style="margin-right: 13px;"
            class="tdesk-form-input"
          >
          <button class="tdesk-secondary-button" type="submit">
            <i class="fas fa-caret-right" />
            Next
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import FormErrors from '../../form_errors';
  import fireGaEvent from './fire_ga_event';

  export default {
    components: {FormErrors},
    props: {
      order: {
        required: true,
        type: Object,
      },
      preselectedContact: {
        required: false,
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        email: this.preselectedContact?.email || null,
        errors: [],
      };
    },
    mounted() {
      $('input').focus();
    },
    methods: {
      checkEmailForExistingAccount() {
        let url = Routes.account_existence_check_enrols_path({email: this.email});
        return axios
            .get(url)
            .then(rsp => {
              if (this.errors.length > 0) {return;}
              if (rsp.data.user) {
                this.$emit('add-contact', rsp.data.user);
              }
              fireGaEvent('ssbc_v2_step3_email');
              this.$emit('set-email', this.email);
              this.$emit('proceed');
            });
      },
      checkEmailForExistingEnrolment() {
        this.errors = [];
        if (!this.order.bookingForSelf) {return this.checkEmailForExistingAccount();}

        let data = {
          email: this.email,
          cid: this.order.course.id,
        };
        let url = Routes.booking_existence_check_enrols_path();
        axios
            .post(url, data)
            .then(rsp => {
              if (rsp.data.error) {return this.errors = [rsp.data.error];}
              this.checkTrainerConflict();
            });
      },
      checkTrainerConflict() {
        let data = {
          email: this.email,
          cid: this.order.course.id,
        };
        let url = Routes.trainer_conflict_check_enrols_path();
        axios
            .post(url, data)
            .then(rsp => {
              if (rsp.data.error) {return this.errors = [rsp.data.error];}
              this.checkEmailForExistingAccount();
            });
      },
      handleSubmit() {
        this.checkEmailForExistingEnrolment();
      },
      proceed() {
        if (!this.email || this.email.length < 1) {
          return;
        }
        this.handleSubmit();
      },

    },
  };
</script>
